import React from "react";
import PropTypes from "prop-types";
import { arrayMove } from "react-sortable-hoc";
import { CollectionAccordion } from "../../shared/Forms";
import FileManagerUI from "../../ui/FileManager";
import SortableGrid from "../../shared/SortableGrid";

class ScreenshotList extends React.Component {
	state = {
		count: 0,
		expandedIndex: null,
		initialLoad: false,
		shouldDisable: false,
		uploadError: "",
	};

	componentDidMount() {
		const { values, scope } = this.props;
		const screenshots = values && values[scope];
		this.setState({ count: screenshots.length, initialLoad: true });
	}

	getOptionsShown = shown => {
		if (shown) {
			this.setState({
				shouldDisable: true,
			});
		} else {
			this.setState({
				shouldDisable: false,
			});
		}
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		const { values, scope, formApi } = this.props;
		if (values && values[scope]) {
			const { setValues } = formApi;
			const screenshots = values[scope];
			setValues({
				...values,
				[scope]: arrayMove(screenshots, oldIndex, newIndex),
			});
		}
	};

	createScreenshot = () => {
		const { count } = this.state;
		this.setState({
			count: count + 1,
			expandedIndex: count,
		});
	};

	deleteScreenshot = index => {
		const { formApi, values, scope } = this.props;
		const { count } = this.state;
		if (values && values[scope].length > 0) {
			const { setValues } = formApi;
			const screenshots = values[scope];
			this.setState(
				{
					count: count - 1,
				},
				setValues({
					...values,
					[scope]: [...screenshots.slice(0, index), ...screenshots.slice(index + 1)],
				})
			);
		} else if (count > 0) {
			this.setState({
				count: count - 1,
			});
		}
	};

	uploadError = (errorMessage, index) => {
		this.setState({ uploadError: errorMessage });
	};

	uploadSuccess = (imgUrl, index) => {
		const { formApi, values, scope } = this.props;
		const existingScreenshots = [...values[scope]];
		existingScreenshots[index] = imgUrl;
		formApi.setValues({
			...values,
			[scope]: existingScreenshots,
		});
	};

	removeFile = (event, index) => {
		event.preventDefault();
		event.stopPropagation();
		const {
			formApi: { setValues },
			values,
			scope,
		} = this.props;
		const screenshots = values[scope];
		screenshots[index] = null;
		setValues({
			...values,
			[scope]: screenshots,
		});
	};

	renderScreenshots = () => {
		const { values, scope } = this.props;
		const { count, expandedIndex, uploadError } = this.state;
		const existingScreenshots = values && values[scope];
		let screenshots = [];
		for (let i = 0; i < count; i++) {
			const screenshotName = existingScreenshots[i]
				? existingScreenshots[i].split("/").pop()
				: `Screenshot ${i + 1}`;
			screenshots.push(
				<CollectionAccordion
					key={i}
					title={screenshotName}
					expanded={expandedIndex === i}
					index={i}
					deleteCollection={this.deleteScreenshot}
					toggleCollectionItem={this.toggleCollectionItem}
					getOptionsShown={this.getOptionsShown}
				>
					<FileManagerUI
						value={existingScreenshots[i]}
						error={uploadError}
						placeholder="Screenshot"
						uploadError={imgUrl => this.uploadError(imgUrl, i)}
						uploadSuccess={imgUrl => this.uploadSuccess(imgUrl, i)}
						removeFile={event => this.removeFile(event, i)}
					/>
				</CollectionAccordion>
			);
		}
		return screenshots;
	};

	render() {
		const { shouldDisable } = this.state;
		return (
			<SortableGrid
				title="Screenshots"
				shouldDisable={shouldDisable}
				createNew={this.createScreenshot}
				onSortEnd={this.onSortEnd}
			>
				{this.renderScreenshots()}
			</SortableGrid>
		);
	}
}

ScreenshotList.propTypes = {
	formApi: PropTypes.object.isRequired,
	scope: PropTypes.string.isRequired,
	values: PropTypes.object.isRequired,
};

export default ScreenshotList;
